import Man2Icon from '@mui/icons-material/Man2';
import WcIcon from '@mui/icons-material/Wc';
import Woman2Icon from '@mui/icons-material/Woman2';

import BusinessIcon from '@mui/icons-material/Business';
import PersonIcon from '@mui/icons-material/Person';

export const defaultLogo = './logos/logo_rnge_crm.svg';
export const defaultTitle = 'SCM';

export const defaultCompanySectors = [
    { value: 1, label: 'Alimentação/Hospedagem' },
    { value: 2, label: 'Associação/Cooperativa' },
    { value: 3, label: 'Atacado/Revenda' },
    { value: 4, label: 'Banco/Financeira' },
    { value: 5, label: 'Clínica/Hospital' },
    { value: 6, label: 'Comércio/Varejo' },
    { value: 7, label: 'Condomínio/Clube' },
    { value: 8, label: 'Construtora/Engenharia' },
    { value: 9, label: 'Escola/Universidade' },
    { value: 10, label: 'Igreja/Templo' },
    { value: 11, label: 'Indústria' },
    { value: 12, label: 'Logística' },
    { value: 13, label: 'Serviço' },
    { value: 14, label: 'Setor Público' },
    { value: 15, label: 'Tecnologia' },
];

export const defaultDealStages = [
    { value: 'OC_AGENDADA', label: 'Analisar' },
    { value: 'OC_RASCUNHO', label: 'Comprar' },
    { value: 'OC_EMITIDA', label: 'Enviar' },
    { value: 'OC_ENVIADA', label: 'Representante' },
    { value: 'OC_A_FATURAR', label: 'A Faturar' },
    { value: 'OC_COM_SALDO', label: 'Saldos' },
    { value: 'OC_INCONSISTENTE', label: 'Inconsistentes' },
];

export const defaultDealPipelineStatuses = ['Fechada/Ganha'];

export const defaultNoteStatuses = [
    { value: 'cold', label: 'Frio', color: '#7dbde8' },
    { value: 'warm', label: 'Morno', color: '#e8cb7d' },
    { value: 'hot', label: 'Quente', color: '#e88b7d' },
    { value: 'converted', label: 'Cliente', color: '#a4e87d' },
];

export const defaultContactGender = [
    { value: 'M', label: 'Masculino', icon: Man2Icon },
    { value: 'F', label: 'Feminino', icon: Woman2Icon },
    { value: 'O', label: 'Outros', icon: WcIcon },
];

export const defaultPersonType = [
    { value: 'PJ', label: 'Pessoa jurídica', icon: BusinessIcon },
    { value: 'PF', label: 'Pessoa física', icon: PersonIcon },
];
